/**
 * Formats a date value (string, Date, or Firestore Timestamp-like object) into a locale string.
 */
export const formatDate = (dateVal: string | { seconds: number; toDate?: () => Date } | Date | unknown): string => {
    if (!dateVal) return 'Unknown';
    
    // Handle Date object
    if (dateVal instanceof Date) return dateVal.toLocaleDateString();
    
    // Handle ISO String
    if (typeof dateVal === 'string') {
        const date = new Date(dateVal);
        return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleDateString();
    }
    
    // Handle Firestore Timestamp object structure (duck typing)
    if (typeof dateVal === 'object' && dateVal !== null) {
        if ('toDate' in dateVal && typeof (dateVal as { toDate: () => Date }).toDate === 'function') {
            return (dateVal as { toDate: () => Date }).toDate().toLocaleDateString();
        }
        if ('seconds' in dateVal && typeof (dateVal as { seconds: number }).seconds === 'number') {
            return new Date((dateVal as { seconds: number }).seconds * 1000).toLocaleDateString();
        }
    }
    
    return 'Unknown';
};